import { EnumRopCards } from "../../dashboard/models/dados-indicadores.model";
import type { CenterOperationsData } from "../types";
import type { RopCard3001CentroDeOperacoesSolarPerformanceDosAtivos } from "./ropCard3001CentroDeOperacoesSolarPerformanceDosAtivos.types";
import type { RopCard3002CentroDeOperacoesSolarEventosDosAtivos } from "./ropCard3002CentroDeOperacoesSolarEventosDosAtivos.types";
import {
  getInverterStatusTotal,
  mapInverterNotifications,
  mapInverterOperationalStatus,
} from "./mapInverterOperationalStatus";

function getEmptyCenterOperationsData(): CenterOperationsData {
  return {
    kpiData: {
      potenciaAtual: 0,
      desvioDeMeta: 0,
      energiaGerada: 0,
      performance: 0,
      disponibilidade: 0,
      IGU: 0,
    },

    iguData: [
      // {
      //   title: "Performance ajustada",
      //   description: "Energia gerada vs esperado",
      //   value: 78,
      //   subValue: 35,
      // },
      // {
      //   title: "Disponibilidade & MTTR",
      //   description: "Tempo disponível e recuperação",
      //   value: 85,
      //   subValue: 20,
      // },
      // {
      //   title: "Integridade do dado",
      //   description: "Qualidade dos dados recebidos",
      //   value: 92,
      //   subValue: 15,
      // },
      // {
      //   title: "Saúde do ativo",
      //   description: "Alarmes e pendências técnicas",
      //   value: 58,
      //   subValue: 15,
      // },
      // {
      //   title: "Execução de evoluções",
      //   description: "Progresso do plano de melhorias",
      //   value: 67,
      //   subValue: 15,
      // },
    ],

    topCausesData: [
      // { title: "INV-01 GFDI em parada total", points: -8 },
      // { title: "Melhoria na limpeza dos painéis", points: 3 },
      // { title: "Atraso na manutenção preventiva", points: -2 },
    ],

    performanceData: [
      // {
      //   name: "US101",
      //   status: "online",
      //   sector: "Setor A",
      //   potencia: 42.3,
      //   eficiencia: 94.2,
      //   irradiancia: 850,
      //   temperatura: 28,
      // },
      // {
      //   name: "US102",
      //   status: "online",
      //   sector: "Setor B",
      //   potencia: 38.1,
      //   eficiencia: 87.5,
      //   irradiancia: 820,
      //   temperatura: 31,
      // },
      // {
      //   name: "US103",
      //   status: "online",
      //   sector: "Setor C",
      //   potencia: 40.7,
      //   eficiencia: 92.8,
      //   irradiancia: 875,
      //   temperatura: 26,
      // },
    ],

    recentEventsData: [
      // {
      //   text: "INV-01 GFDI - parada total",
      //   hour: "12:45",
      //   status: "danger",
      // },
      // {
      //   text: "SBX-09 com 30% abaixo do esperado",
      //   hour: "12:32",
      //   status: "warning",
      // },
      // {
      //   text: "SEN-10 oscilando comunicação",
      //   hour: "12:18",
      //   status: "warning",
      // },
    ],

    suggestionEventsData: [
      // {
      //   severity: "alta",
      //   text: "Acionar suporte técnico para verificação do INV-01 (GFDI)",
      // },
      // {
      //   severity: "media",
      //   text: "Programar inspeção em SBX-09 e revisão de conexões em campo",
      // },
      {
        severity: "baixa",
        text: "Nenhuma sugestão no momento",
      },
    ],

    ativosDaUsina: [
      // {
      //   planta: "US-01",
      //   alarmCode: "ALM200",
      //   nomeDoAtivo: "INV-001",
      //   status: "Critico",
      //   ultimoAlarme: "12:45",
      //   tempoParado: "2h 15min",
      //   isActive: true,
      //   description: "GFDI - Falha de isolamento",
      // },
      // {
      //   planta: "US-02",
      //   alarmCode: "ALM102",
      //   nomeDoAtivo: "TRK-002",
      //   status: "Atencao",
      //   ultimoAlarme: "11:30",
      //   tempoParado: "45min",
      //   isActive: true,
      //   description: "Desvio de posicionamento",
      // },
      // {
      //   planta: "US-01",
      //   alarmCode: "ALM105",
      //   nomeDoAtivo: "INV-003",
      //   status: "Leve",
      //   ultimoAlarme: "-",
      //   tempoParado: "-",
      //   isActive: true,
      //   description: "Performance 5% abaixo",
      // },
      // {
      //   planta: "US-03",
      //   alarmCode: "ALM301",
      //   nomeDoAtivo: "SBX-004",
      //   status: "Atencao",
      //   ultimoAlarme: "10:22",
      //   tempoParado: "1h 30min",
      //   isActive: true,
      //   description: "Corrente 30% abaixo do esperado",
      // },
      // {
      //   planta: "US-02",
      //   alarmCode: "ALM108",
      //   nomeDoAtivo: "INV-005",
      //   status: "Leve",
      //   ultimoAlarme: "-",
      //   tempoParado: "-",
      //   isActive: true,
      //   description: "Temperatura elevada",
      // },
      // {
      //   planta: "US-01",
      //   alarmCode: "ALM103",
      //   nomeDoAtivo: "TRK-006",
      //   status: "Leve",
      //   ultimoAlarme: "-",
      //   tempoParado: "-",
      //   isActive: true,
      //   description: "Limpeza necessária",
      // },
    ],

    iguScoreData: {
      value: 0,
      last7days: 0,
      last30days: 0,
    },

    equipamentosInfoData: [
      // {
      //   title: "Inversores",
      //   online: 45,
      //   offline: 1,
      //   maintenance: 2,
      //   percent: 93.8,
      //   updatedAt: "12:45",
      // },
      // {
      //   title: "Trackers",
      //   online: 22,
      //   offline: 0,
      //   maintenance: 2,
      //   percent: 91.7,
      //   updatedAt: "12:44",
      // },
    ],

    isRopCard3001Loaded: false,
    isRopCard3002Loaded: false,
  };
}

function fillEficienciaIfUsinaExists(
  card3002: RopCard3002CentroDeOperacoesSolarEventosDosAtivos,
  centerOperationsData: CenterOperationsData,
): CenterOperationsData {
  const updatedPerformanceData = centerOperationsData.performanceData.map(
    (item) => {
      return {
        ...item,
        eficiencia: getUsinaEfficiencyByUsinaCode(
          card3002,
          item.name,
          item.activeSensorsPercentage,
        ),
      };
    },
  );
  return {
    ...centerOperationsData,
    performanceData: updatedPerformanceData,
  };
}

interface EquipmentMetrics {
  percentage: number | null;
  totalAmount: number;
}

function getInverterMetrics(
  card3002: RopCard3002CentroDeOperacoesSolarEventosDosAtivos,
  usinaCode: string,
): EquipmentMetrics {
  return {
    percentage: card3002.ropCard25InvertersMonitorAggregatedCollection
      .activeInvertersPercentageByUsina[usinaCode]
      ? card3002.ropCard25InvertersMonitorAggregatedCollection
          .activeInvertersPercentageByUsina[usinaCode]
      : null,
    totalAmount:
      card3002.ropCard25InvertersMonitorAggregatedCollection
        .invertersAmountByUsina[usinaCode] ?? 0,
  };
}

function getStringMetrics(
  card3002: RopCard3002CentroDeOperacoesSolarEventosDosAtivos,
  usinaCode: string,
): EquipmentMetrics {
  return {
    percentage:
      card3002.ropCard26StringsMonitorAggregatedCollection
        .activeStringsPercentageByUsina[usinaCode] ?? null,
    totalAmount:
      card3002.ropCard26StringsMonitorAggregatedCollection.stringsAmountByUsina[
        usinaCode
      ] ?? 0,
  };
}

function getTrackerMetrics(
  card3002: RopCard3002CentroDeOperacoesSolarEventosDosAtivos,
  usinaCode: string,
): EquipmentMetrics {
  return {
    percentage:
      card3002.ropCard27TrackersMonitorAggregatedCollection
        .activeTrackersPercentageByUsina[usinaCode] ?? null,
    totalAmount:
      card3002.ropCard27TrackersMonitorAggregatedCollection
        .trackersAmountByUsina[usinaCode] ?? 0,
  };
}

function getSensorMetrics(
  card3002: RopCard3002CentroDeOperacoesSolarEventosDosAtivos,
  usinaCode: string,
  activeSensorsPercentage: number | null,
): EquipmentMetrics {
  return {
    percentage: activeSensorsPercentage,
    totalAmount:
      card3002.ropCard28SensorsMonitorAggregatedCollection.sensorsAmountByUsina[
        usinaCode
      ] ?? 0,
  };
}

function isValidMetricForEfficiency(metrics: EquipmentMetrics): boolean {
  return metrics.percentage !== null && metrics.totalAmount > 0;
}

function getUsinaEfficiencyByUsinaCode(
  card3002: RopCard3002CentroDeOperacoesSolarEventosDosAtivos,
  usinaCode: string,
  activeSensorsPercentage: number | null,
): number | null {
  const allMetrics = [
    getInverterMetrics(card3002, usinaCode),
    getStringMetrics(card3002, usinaCode),
    getTrackerMetrics(card3002, usinaCode),
    getSensorMetrics(card3002, usinaCode, activeSensorsPercentage),
  ];

  const validPercentages = allMetrics
    .filter(isValidMetricForEfficiency)
    .map((metrics) => metrics.percentage as number);

  if (validPercentages.length === 0) {
    return null;
  }

  return (
    validPercentages.reduce((sum, percentage) => sum + percentage, 0) /
    validPercentages.length
  );
}

function ropCard3001ToPartialCenterOperationsData(
  ropCard3001: RopCard3001CentroDeOperacoesSolarPerformanceDosAtivos,
  prevCenterOperationsData: CenterOperationsData | null,
): Pick<
  CenterOperationsData,
  "kpiData" | "performanceData" | "isRopCard3001Loaded" | "equipamentosInfoData"
> {
  var sensorEquipmentInfo = prevCenterOperationsData?.equipamentosInfoData.find(
    (info) => info.title === "Sensores",
  );

  var equipmentsInfoWithoutSensors =
    prevCenterOperationsData?.equipamentosInfoData.filter(
      (info) => info.title !== "Sensores",
    );

  var sensorNotificationsWithoutOfflineNotification =
    prevCenterOperationsData?.equipamentosInfoData
      .find((info) => info.title === "Sensores")
      ?.notifications.filter((n) => n.title !== "Sensores Offline");

  const previousEfficiencyMap = new Map(
    prevCenterOperationsData?.performanceData.map((item) => [
      item.name,
      item.eficiencia,
    ]) ?? [],
  );

  const previousPerformanceRatioMap = new Map(
    prevCenterOperationsData?.performanceData.map((item) => [
      item.name,
      item.performanceRatio,
    ]) ?? [],
  );

  return {
    kpiData: {
      potenciaAtual:
        ropCard3001.ropCard20AggregatedCollection?.aggregatedCard?.value ?? 0,
      desvioDeMeta:
        ropCard3001.ropCard23AggregatedCollection?.aggregatedCard?.value ?? 0,
      energiaGerada:
        ropCard3001.ropCard03AggregatedCollection?.aggregatedCard?.value ?? 0,
      performance:
        ropCard3001.ropCard02AggregatedCollection?.aggregatedCard?.value ?? 0,
      disponibilidade:
        ropCard3001.ropCard05AggregatedCollection?.aggregatedCard?.value ?? 0,
      IGU: 0,
    },

    performanceData: [
      ...ropCard3001.assetsPerformance.map((asset) => {
        const assetName = asset.usinaName ?? asset.usinaCode;

        return {
          name: assetName,
          status: "online",
          sector: assetName, // TODO:
          potencia: asset.potenciaAtiva,
          performanceRatio:
            asset.performanceRatio ??
            asset.eficienciaOperacional ??
            previousPerformanceRatioMap.get(assetName) ??
            previousPerformanceRatioMap.get(asset.usinaCode) ??
            null,
          eficiencia:
            previousEfficiencyMap.get(assetName) ??
            previousEfficiencyMap.get(asset.usinaCode) ??
            null,
          irradiancia: asset.irradiancia,
          irradianciaMaxima: asset.irradianciaMaxima,
          temperatura: asset.temperatura,
          activeSensorsPercentage: asset.activeSensorsPercentage,
        } as CenterOperationsData["performanceData"][number];
      }),

      ...(ropCard3001.unavailableUsinas &&
      ropCard3001.unavailableUsinas.length > 0
        ? ropCard3001.unavailableUsinas.map(
            (
              unavailableUsina,
            ): CenterOperationsData["performanceData"][number] => ({
              name: unavailableUsina.code,
              status: "offline",
              sector: unavailableUsina.code, // TODO:
              message: unavailableUsina.message,
              potencia: 0,
              performanceRatio: null,
              eficiencia: null,
              irradiancia: 0,
              irradianciaMaxima: 0,
              temperatura: 0,
              activeSensorsPercentage: null,
            }),
          )
        : []),
    ],

    equipamentosInfoData: [
      ...(equipmentsInfoWithoutSensors ?? []),
      ...(sensorEquipmentInfo &&
      ropCard3001.ropCard30AggregatedCollection?.aggregatedCard
        ? [
            {
              title: "Sensores",
              online:
                ropCard3001.ropCard30AggregatedCollection.aggregatedCard
                  .totalOnlineSensors,
              offline:
                ropCard3001.ropCard30AggregatedCollection.aggregatedCard
                  .totalOfflineSensors,
              maintenance: sensorEquipmentInfo.maintenance,
              percent:
                ropCard3001.ropCard30AggregatedCollection.aggregatedCard
                  .activeSensorsPercentage,
              updatedAt: ropCard3001.updatedAt,
              notifications: [
                {
                  title: "Sensores Offline",
                  type: "critical",
                  items:
                    ropCard3001.ropCard30AggregatedCollection.aggregatedCard
                      .offlineSensors,
                },
                ...(sensorNotificationsWithoutOfflineNotification ?? []),
              ] as any,
              performance: 0,
              hidePerformance: true,
              totalUnits:
                ropCard3001.ropCard30AggregatedCollection.aggregatedCard
                  .totalUsinas,
            },
          ]
        : []),
    ],
    isRopCard3001Loaded: true,
  };
}

function ropCard3002ToPartialCenterOperationsData(
  ropCard3002: RopCard3002CentroDeOperacoesSolarEventosDosAtivos,
  prevCenterOperationsData: CenterOperationsData | null,
): Pick<
  CenterOperationsData,
  | "recentEventsData"
  | "ativosDaUsina"
  | "equipamentosInfoData"
  | "isRopCard3002Loaded"
> {
  const eventSeverityToStatus = (severity: number): "warning" | "danger" => {
    switch (severity) {
      case 3:
        return "danger";
      case 1:
      case 2:
      default:
        return "warning";
    }
  };

  const alarmSeverityToStatus = (
    severity: number,
  ): "Critico" | "Atencao" | "Leve" | "Nao Informado" => {
    switch (severity) {
      case 1:
        return "Leve";
      case 2:
        return "Atencao";
      case 3:
        return "Critico";
      default:
        return "Nao Informado";
    }
  };

  var prevSensorEquipmentInfo =
    prevCenterOperationsData?.equipamentosInfoData.find(
      (info) => info.title === "Sensores",
    );

  var sensorNotificationsWithoutCommunicationNotification =
    prevCenterOperationsData?.equipamentosInfoData
      .find((info) => info.title === "Sensores")
      ?.notifications.filter((n) => n.title !== "Sensores sem comunicação");

  const card25 = ropCard3002.ropCard25InvertersMonitorAggregatedCollection;
  const inverterOperationalStatuses = mapInverterOperationalStatus(card25);

  return {
    recentEventsData: ropCard3002.instantAlarmEvents
      .slice(0, 10)
      .map((instantAlarmEvent) => ({
        usinaCode: instantAlarmEvent.usinaCode,
        text: `${instantAlarmEvent.area}.${instantAlarmEvent.code} ${instantAlarmEvent.message}`,
        hour: instantAlarmEvent.triggeredAt,
        status: eventSeverityToStatus(instantAlarmEvent.severity),
      })),

    ativosDaUsina: ropCard3002.currentAlarms.map((alarm) => ({
      planta: alarm.usinaName ?? alarm.usinaCode,
      alarmUsinaId: alarm.powerPlantKey,
      alarmCode: alarm.code,
      alarmUg: alarm.equipmentIdentifier,
      alarmArea: alarm.areaCode,
      alarmString: alarm.area,
      alarmMessage: alarm.message,
      alarmLastActiveDate: alarm.triggeredAt,
      nomeDoAtivo: alarm.area,
      status: alarmSeverityToStatus(alarm.severity),
      ultimoAlarme: alarm.triggeredAt,
      tempoParado: alarm.alarmDuration,
      isActive: alarm.isActive,
      description: alarm.message,
      usinaPhoneNumber: alarm.usinaPhoneNumber,
    })),

    equipamentosInfoData: [
      {
        title: "Inversores",
        online: getInverterStatusTotal(inverterOperationalStatuses, "generating"),
        offline: getInverterStatusTotal(inverterOperationalStatuses, "failure"),
        maintenance: getInverterStatusTotal(
          inverterOperationalStatuses,
          "communicationFailure",
        ),
        performance: getInverterStatusTotal(
          inverterOperationalStatuses,
          "performance",
        ),
        available: getInverterStatusTotal(
          inverterOperationalStatuses,
          "available",
        ),
        percent: card25.activeInverterPercentage,
        updatedAt: ropCard3002.updatedAt,
        operationalStatuses: inverterOperationalStatuses,
        notifications: mapInverterNotifications(inverterOperationalStatuses),
        totalUnits: card25.totalInverters,
      },
      {
        title: "Strings",
        online:
          ropCard3002.ropCard26StringsMonitorAggregatedCollection
            .totalActiveStrings,
        offline:
          ropCard3002.ropCard26StringsMonitorAggregatedCollection
            .totalOfflineStrings,
        maintenance:
          ropCard3002.ropCard26StringsMonitorAggregatedCollection
            .totalwithoutCommunicationStrings,
        percent:
          ropCard3002.ropCard26StringsMonitorAggregatedCollection
            .activeStringPercentage,
        updatedAt: ropCard3002.updatedAt,
        notifications: [
          {
            title: "Strings Offline",
            type: "critical",
            items:
              ropCard3002.ropCard26StringsMonitorAggregatedCollection
                .offlineStrings,
          },
          {
            title: "Alarmes de performance",
            type: "performance",
            items:
              ropCard3002.ropCard26StringsMonitorAggregatedCollection
                .performanceStrings,
          },
          {
            title: "Strings sem comunicação",
            type: "communication",
            items:
              ropCard3002.ropCard26StringsMonitorAggregatedCollection
                .withoutCommunicationStrings,
          },
        ],
        performance:
          ropCard3002.ropCard26StringsMonitorAggregatedCollection
            .totalPerformanceStrings,
        totalUnits:
          ropCard3002.ropCard26StringsMonitorAggregatedCollection.totalStrings,
      },
      {
        title: "Trackers",
        online:
          ropCard3002.ropCard27TrackersMonitorAggregatedCollection
            .totalActiveTrackers,
        offline:
          ropCard3002.ropCard27TrackersMonitorAggregatedCollection
            .totalOfflineTrackers,
        maintenance:
          ropCard3002.ropCard27TrackersMonitorAggregatedCollection
            .totalwithoutCommunicationTrackers,
        percent:
          ropCard3002.ropCard27TrackersMonitorAggregatedCollection
            .activeTrackerPercentage,
        updatedAt: ropCard3002.updatedAt,
        notifications: [
          {
            title: "Trackers Offline",
            type: "critical",
            items:
              ropCard3002.ropCard27TrackersMonitorAggregatedCollection
                .offlineTrackers,
          },
          /*           {
            title: "Alarmes de performance",
            type: "performance",
            items:
              ropCard3002.ropCard27TrackersMonitorAggregatedCollection
                .performanceTrackers,
          }, */
          {
            title: "Trackers sem comunicação",
            type: "communication",
            items:
              ropCard3002.ropCard27TrackersMonitorAggregatedCollection
                .withoutCommunicationTrackers,
          },
        ],
        performance: 0,
        hidePerformance: true,
        totalUnits:
          ropCard3002.ropCard27TrackersMonitorAggregatedCollection
            .totalTrackers,
      },
      {
        title: "Sensores",
        online: prevSensorEquipmentInfo?.online ?? 0,
        offline: prevSensorEquipmentInfo?.offline ?? 0,
        maintenance:
          ropCard3002.ropCard28SensorsMonitorAggregatedCollection
            .totalWithoutCommunicationSensors,
        percent: prevSensorEquipmentInfo?.percent ?? 0,
        updatedAt: ropCard3002.updatedAt,
        notifications: [
          ...(sensorNotificationsWithoutCommunicationNotification ?? []),
          {
            title: "Sensores sem comunicação",
            type: "communication",
            items:
              ropCard3002.ropCard28SensorsMonitorAggregatedCollection
                .withoutCommunicationSensors,
          },
        ],
        performance: 0,
        hidePerformance: true,
        totalUnits: prevSensorEquipmentInfo?.totalUnits ?? 0,
      },
      {
        title: "Transformadores",
        online: 0,
        offline: 0,
        maintenance: 0,
        percent: 0,
        updatedAt: ropCard3002.updatedAt,
        notifications: [
          {
            title: "Alarmes de temperatura",
            type: "communication",
            items:
              ropCard3002.ropCard29TrafoMonitorAggregatedCollection
                .trafosWithTemperatureAlarm,
          },
        ],
        performance: 0,
        isTrafo: true,
        totalUnits:
          ropCard3002.ropCard29TrafoMonitorAggregatedCollection.totalTrafos,
      },
    ],

    isRopCard3002Loaded: true,
  };
}

export function ropCardToCenterOperationsData(
  ropCardUpdate: any,
  prevCenterOperationsData: CenterOperationsData | null,
): CenterOperationsData {
  if (
    ropCardUpdate.type ===
    EnumRopCards.RopCard3001CentroDeOperacoesSolarPerformanceDosAtivos
  ) {
    const ropCard3001 =
      ropCardUpdate as RopCard3001CentroDeOperacoesSolarPerformanceDosAtivos;

    const partialData = ropCard3001ToPartialCenterOperationsData(
      ropCard3001,
      prevCenterOperationsData,
    );

    const previousEquipamentosInfoData =
      prevCenterOperationsData?.equipamentosInfoData.filter(
        (info) =>
          info.title !== "Inversores" &&
          info.title !== "Strings" &&
          info.title !== "Trackers" &&
          info.title !== "Sensores" &&
          info.title !== "Transformadores",
      ) ?? [];

    return {
      ...(prevCenterOperationsData ?? getEmptyCenterOperationsData()),
      ...partialData,
      equipamentosInfoData: [
        ...previousEquipamentosInfoData,
        ...(partialData.equipamentosInfoData ?? []),
      ],
    };
  }

  if (
    ropCardUpdate.type ===
    EnumRopCards.RopCard3002CentroDeOperacoesSolarEventosDosAtivos
  ) {
    const ropCard3002 =
      ropCardUpdate as RopCard3002CentroDeOperacoesSolarEventosDosAtivos;

    const partialData = ropCard3002ToPartialCenterOperationsData(
      ropCard3002,
      prevCenterOperationsData,
    );

    const previousEquipamentosInfoData =
      prevCenterOperationsData?.equipamentosInfoData.filter(
        (info) =>
          info.title !== "Inversores" &&
          info.title !== "Strings" &&
          info.title !== "Trackers" &&
          info.title !== "Sensores" &&
          info.title !== "Transformadores",
      ) ?? [];

    const performanceData = prevCenterOperationsData?.performanceData
      ? fillEficienciaIfUsinaExists(ropCard3002, prevCenterOperationsData)
          .performanceData
      : undefined;

    return {
      ...(prevCenterOperationsData ?? getEmptyCenterOperationsData()),
      ...partialData,
      equipamentosInfoData: [
        ...previousEquipamentosInfoData,
        ...(partialData.equipamentosInfoData ?? []),
      ],
      performanceData: performanceData ?? [],
    };
  }

  throw new Error("Tipo de RopCard desconhecido para conversão");
}
